import React from 'react';
import {useNavigate} from "react-router-dom";
import ShareIcon from "../../../util/svg/nicebutton/ShareIcon";
import {useSessionConfiguration} from "../../../util/SessionConfigurationContext";


const UnderImageDetailPane = ({isMyImage, imageId, imageTop, imageTrending}) => {
    const {isDesktopView} = useSessionConfiguration();

    const navigate = useNavigate();
    const handleShareClick = () => {
        navigate(`/image/share/${imageId}`);
    };

    const goToTrending = () => {
        navigate('/trending?index=' + (imageTrending - 1));
    }

    const goToTop = () => {
        navigate('/?index=' + (imageTop - 1));
    }

    return (
        <div className="under-image-content">
            <div className={`under-image-position ${isDesktopView ? 'enlarged' : ''}`} onClick={goToTrending}>
                {'trending #' + imageTrending}
            </div>

            <div className={`under-image-position ${isDesktopView ? 'enlarged' : ''}`} onClick={goToTop}>
                {'all time #' + imageTop}
            </div>

            {isMyImage ? (
                <div className={`under-image-position ${isDesktopView ? 'enlarged' : ''}`} onClick={handleShareClick}>
                    <ShareIcon size={'16px'} color={'#809885'}/>
                    share
                </div>
            ) : <div/>}
        </div>
    );
};

export default UnderImageDetailPane;
